export default "__VITE_ASSET__f450b7ff__"